import Component from './Component';

export default class ShowMorePopup extends Component {
	load() {
		this.initShowMorePopup();

		super.load();
	}

	initShowMorePopup() {
    // console.log('initShowMorePopup');

    // add event listeners
    const containerString = '.related-content__list';
    const showMoreLinks = document.querySelectorAll(`${containerString} .js-show-more-popup`);
    const popupCloses = document.querySelectorAll(`${containerString} .js-popup-close`);

    showMoreLinks.forEach(button => {
      button.addEventListener("click", actionPopup);
    });

    popupCloses.forEach(button => {
      button.addEventListener("click", actionPopup);
    });


    function actionPopup(event) {
      // console.log("target info: ", event.target);

      // navigate up the DOM to the closest parent then down to it's popup
      const parentEl = event.target.closest('.tile__content');
      const popupEl = parentEl.querySelector('.tile__popup');
      const linkEl = parentEl.querySelector('.js-show-more-popup');
      // console.log("popupEl: ", popupEl);

      toggleElement(popupEl);  // .parentElement

      // change link text
      linkEl.innerText =
        linkEl.innerText === "...Show more" ? "...Show less" : "...Show more";
    }


    function toggleElement(targetEl) {
      // console.log("toggle targetEl: ", targetEl);
      targetEl.style.visibility =
        targetEl.style.visibility === "hidden" ? "" : "hidden";
    }

	}

}
